<template>
  <div>
    <div style="margin-bottom:5px" :class="['dropdown_select_container', !isEditable ? 'view_only' : '']">
      <v-select v-if="isEditable" id="assignedToPartnerNationId" style="min-width:265px" v-model="partnerNationId"
        @input="viewModal" :reduce="(user) => user.id" label="name" :options="filteredUsers"
        :selectable="option => !option.isDisabled" placeholder="Choose...">
        <template v-slot:option="option">
          {{ option.nameLabel }}
        </template>
      </v-select>
      <p class="dropdown_text_wrap" v-else> <i v-if="selectedUserLabel.isLocked" class="tim-icons icon-lock-circle"
          aria-hidden="true"></i>
        {{ selectedUserLabel.label }} </p>


      <el-button style="margin-left:2px" size="mini" v-if="countryId && !isPartnerAccount && !isReadOnly"
        :class="isEditable ? 'editing' : 'btn-secondary'" v-show="!isReadOnly"
        :icon="isEditable ? 'el-icon-close' : 'el-icon-edit'" @click="toggleEdit()"
        :disabled="$route.params.id <= 0"></el-button>
    </div>

    <!-- small modal -->
    <modal :showClose="false" :show.sync="modals.notice" headerClasses="justify-content-center" type="notice">
      <h4 slot="header" class="title title-up">
        {{ selectedUserId === null ? 'REMOVE PARTNER NATION USER' : 'ASSIGN PARTNER NATION USER' }}
      </h4>
      <hr />
      <div class="container">
        <div class="form-group">
          <base-checkbox v-model="sendAssignerCopy">Send Me a Copy</base-checkbox>
        </div>
        <div class="row">
          <div class="col-md-12">
            <base-input label="Note">
              <textarea class="form-control" placeholder="Add a brief description" rows="5" v-model="note"></textarea>
            </base-input>
          </div>
        </div>
      </div>
      <template slot="footer">
        <div class="container alert_footer">
          <base-button style="margin-right: 2px" type="danger" class="alert_footer_button btn_extra_small btn_info"
            @click.native="cancel">
            Close
          </base-button>
          <base-button type="primary" class="alert_footer_button btn_extra_small btn_info" @click.native="confirm">
            Confirm
          </base-button>
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import { Modal, BaseButton, BaseCheckbox } from "@/components";
import { EventBus } from "@/event-bus.js";
import {
  Button,
} from "element-ui";
export default {
  name: "partner-user-select",
  props: ["isLogisticsUser", "isReadOnly", "countryId", "isPartnerAccount"],
  data() {
    return {
      modals: {
        notice: false,
      },
      sendAssignerCopy: false,
      note: null,
      selectedUserId: null,
      removedUserId: null,
      isEditable: false
    };
  },
  components: {
    Modal,
    BaseButton,
    BaseCheckbox,
    EventBus,
    [Button.name]: Button,
  },
  computed: {
    ...mapGetters({
      partnerNationUsers: "users/partnerNationUsers",
      orderMetadata: "orderMetadata/orderMetadata",
      isLogistics: "authentication/isLogistics",
      isFinance: "authentication/isFinance",
      isSponsor: "authentication/isSponsor",
      countryUpdated: "implementArrangment/countryUpdated",
    }),
    partnerNationId: {
      get() {
        return this.$store.getters["orderMetadata/partnerNationId"];
      },
      set(value) {
        // v-model binding - value stored temporarily in selectedUserId via viewModal
        // Actual Vuex state update happens in confirm() method via onPartnerNationChange action
      }
    },
    isCompletedOrder() {
      return this.orderMetadata.orderStatus == "COMPLETED";
    },
    selectedUserLabel() {
      // Three-step user resolution:
      // 1) orderMetadata.partnerNationUserNameLabel - authoritative source from backend (Name (email) format)
      // 2) partnerNationUsers dropdown array - for locked status detection and editing
      // 3) transaction.partnerNationUser object - backup for locked status

      let userIdToFind;

      if (this.selectedUserId) {
        userIdToFind = this.selectedUserId;
      } else {
        userIdToFind = this.partnerNationId;
      }

      // If no user ID, return default message
      if (!userIdToFind) {
        return { label: 'No Partner user selected', isLocked: false };
      }

      // Primary: Use orderMetadata label (always available from backend)
      if (this.orderMetadata && this.orderMetadata.partnerNationUserNameLabel) {
        // Check if user is locked via dropdown array or transaction
        let isLocked = false;
        const selectedUser = this.partnerNationUsers.find(user => (user.id || '').toLowerCase() === (userIdToFind || '').toLowerCase());
        if (selectedUser) {
          isLocked = selectedUser.isDisabled || false;
        } else if (this.$store.getters["transactions/transaction"] && this.$store.getters["transactions/transaction"].partnerNationUser) {
          const pnUser = this.$store.getters["transactions/transaction"].partnerNationUser;
          if ((pnUser.userId || '').toLowerCase() === (userIdToFind || '').toLowerCase()) {
            isLocked = pnUser.isDisabled || false;
          }
        }
        return { label: this.orderMetadata.partnerNationUserNameLabel, isLocked: isLocked };
      }

      // Fallback for dropdown array (when editing)
      const selectedUser = this.partnerNationUsers.find(user => (user.id || '').toLowerCase() === (userIdToFind || '').toLowerCase());
      if (selectedUser) {
        return { label: selectedUser.nameLabel, isLocked: selectedUser.isDisabled || false };
      }

      // Fallback for transaction object
      if (this.$store.getters["transactions/transaction"] && this.$store.getters["transactions/transaction"].partnerNationUser) {
        const pnUser = this.$store.getters["transactions/transaction"].partnerNationUser;
        const pnUserIdMatch = (pnUser.userId || '').toLowerCase() === (userIdToFind || '').toLowerCase();
        if (pnUserIdMatch) {
          const userName = (pnUser.userName && pnUser.userName.trim()) ? pnUser.userName : pnUser.userEmail;
          return {
            label: `${userName} (${pnUser.userEmail})`,
            isLocked: pnUser.isDisabled || false
          };
        }
      }

      // Should never reach here - backend always provides label
      return { label: 'No Partner user selected', isLocked: false };
    },
    filteredUsers() {
      // Completely filter out all locked users from dropdown selection
      // Locked users can still be displayed if currently assigned, but cannot be selected
      return this.partnerNationUsers.filter((e) => !e.isDisabled)
    }
  },

  watch: {
    logisticsUserId: function () {
      return this.check();
    },

    countryId: async function (newVal) {
      if (newVal) {
        // If country changes, remove existing user assignment 
        // before loading new users for the newly selected country
        this.selectedUserId = null

        await this.getPartnerNationUsers(newVal)
        this.isEditable = false

      } else {
        return
      }
    },
    countryUpdated: function (val) {
      this.updatePartnerNationVal(val);
      return
    },
  },
  async mounted() {
    this.getCountryUpdatedCount(0)
    this.getOrderMetadata(this.$route.params.id).then(() => {
      this.removedUserId = this.partnerNationId
    });
    await this.getTransaction(this.$route.params.id);
    this.selectedUserId = this.partnerNationId

  },
  methods: {
    ...mapActions({
      onPartnerNationChange: "orderMetadata/onPartnerNationChange",
      getOrderMetadata: "orderMetadata/getOrderMetadata",
      removeUser: "orderMetadata/removeUser",
      getPartnerNationUsers: "users/getPartnerNationUsers",
      getCountryUpdatedCount: 'implementArrangment/getCountryUpdatedCount',
      getTransaction: "transactions/getTransaction",

    }),
    viewModal(e) {

      this.selectedUserId = e;
      this.modals.notice = true;
    },
    updatePartnerNationVal(val) {
      if (this.orderMetadata) {
        if (val !== 0) {
          this.$store.commit("orderMetadata/SET_PARTNERNATION_USER_ID", null);
        }
      }
    },
    async toggleEdit() {
      if (this.isEditable) {
        await this.cancel();
        this.isEditable = false
      } else {
        this.isEditable = true
      }
    },
    check() {
      let ctx = this;
      // is the user is no longer in the partneration dropdown remove them
      let exists = ctx.partnerNationUsers.find(
        (user) => user.id == ctx.partnerNationId
      );

      if (!exists && ctx.logisticsUserId) {
        ctx.$store.commit("orderMetadata/SET_PARTNERNATION_USER_ID", null);
      }
    },
    async cancel(e) {
      let ctx = this;
      await ctx.getOrderMetadata(ctx.$route.params.id);
      ctx.modals.notice = false;
    },
    confirm(e) {
      let ctx = this;
      try {
        this.$loaderApp.addRequest();
        if (this.selectedUserId === null) {
          ctx.removeUser({
            orderId: ctx.$route.params.id,
            userId: ctx.removedUserId
          }).then(() => {
            ctx.$toast.success("Partner Nation user removed successfully");
            ctx.getOrderMetadata(ctx.$route.params.id).then(() => {
              ctx.removedUserId = null
            });
            ctx.selectedUserId = null
            this.isEditable = false
          });
        } else {
          ctx.onPartnerNationChange({
            orderId: ctx.$route.params.id,
            sendAssignerCopy: ctx.sendAssignerCopy,
            note: ctx.note,
            selectedUserId: ctx.selectedUserId,
          }).then(() => {
            EventBus.$emit('pn-user-change', ctx.$route.params.id);
            this.isEditable = false
            ctx.getOrderMetadata(ctx.$route.params.id).then(() => {
              ctx.removedUserId = ctx.partnerNationId
            });
          });
        }
        ctx.modals.notice = false;
        this.isEditable = false
        this.$loaderApp.completeRequest();

      } catch (error) {
        this.$loaderApp.completeRequest();
        this.isEditable = false
        ctx.$toast.error("Error Occurred! Please try again later.");
      }
    },
  },
};
</script>

<style scoped>
.el-button.editing {
  color: #fff;
  border-color: red;
  background-color: red;
}

.vue-treeselect__control {
  width: 90% !important;
}
</style>
